module.exports = __webpack_public_path__ + "img/防汛监测预警系统V1.0.7ef6c59f.jpg";